interface WorkoutProgressBarProps {
  percentage: number;
}

export function WorkoutProgressBar({ percentage }: WorkoutProgressBarProps) {
  const clampedPercentage = Math.max(0, Math.min(100, percentage));

  return (
    <div
      className="relative h-[3px] w-full bg-gray-200 dark:bg-white/10"
      data-testid="workout-overall-progress"
      role="progressbar"
      aria-label={`Workout progress: ${clampedPercentage}%`}
      aria-valuenow={clampedPercentage}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="absolute inset-y-0 left-0 bg-brand-600 transition-[width] duration-500 ease-out dark:bg-brand-400"
        style={{ width: `${clampedPercentage}%` }}
        data-testid="workout-overall-progress-bar"
      />
      <span className="sr-only" data-testid="workout-overall-progress-percentage">
        {clampedPercentage}%
      </span>
    </div>
  );
}
